export default function createConfirmationLinksMixin(returnPath) {
  return {
    computed: {
      isMobileDevice() {
        const userAgent = navigator.userAgent.toLowerCase()
        return /android|webos|iphone|ipad|ipod|blackberry|windows phone/.test(
          userAgent
        )
      },
      confirmLink() {
        const token = this.$route.query.token
        const uid = this.$route.query.uid

        const url = new URL(window.location.href)
        const hostname = url.hostname.split('.')
        const environment = hostname[0]

        const environmentMap = {
          staging: 'hbp-staging',
          dev: 'hbp-development',
          'hbp-dev2': 'hbp-dev2',
          'hbp-qa3': 'hbp-qa3',
          'hbp-stg2': 'hbp-stg2',
          silverhand: 'hbp-silverhand',
          myhealthbookplus: 'hbp', // For production without subdomain
        }
        const customScheme = environmentMap[environment] || 'hbp'

        return `${customScheme}://${returnPath}?token=${token}&uid=${uid}`
      },
      qrCodeLink() {
        return window.location.href
      },
    },
  }
}
